"use strict";

// Class definition
var KTChartsWidget39 = (function () {
  // Private methods

  var initChart = function (chartSelector) {
    var element = document.querySelector(chartSelector);

    if (!element) {
      return;
    }

    var height = parseInt(KTUtil.css(element, "height"));

    var options = {
        chart: {
          height: height || 300,
          type: "radialBar",
        },
        series: [67],
        colors: ["#20E647"],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: '#333',
              startAngle: -90,
              endAngle: 90,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                fontSize: "30px",
                show: true
              }
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            gradientToColors: ["#87D4F9"],
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: "butt"
        },
        labels: ["Progress"]
      };
    var chart = new ApexCharts(element, options);
    chart.render();
  };

  // Public methods
  return {
    init: function () {
      initChart("#kt_custom_angle_circle");
    },
  };
})();

// Webpack support
if (typeof module !== "undefined") {
  module.exports = KTChartsWidget39;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget39.init();
});
